var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.431042 0.372156C0.132106 0.730867 -0.0187795 1.19008 0.00914484 1.65619V21.9439C-0.0187795 22.41 0.132106 22.8692 0.431042 23.2279L0.495243 23.2921L11.8589 11.9376V11.6716L0.495243 0.307953L0.431042 0.372156Z",
    fill: "url(#paint0_linear_594_58)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6193 15.7255L11.8589 11.9376V11.6716L15.6193 7.87457L15.7018 7.92043L20.2051 10.4793C21.4891 11.2039 21.4891 12.3962 20.2051 13.1299L15.7202 15.6797L15.6193 15.7255Z",
    fill: "url(#paint1_linear_594_58)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7295 15.6705L11.859 11.8L0.431152 23.2279C0.692877 23.458 1.02675 23.5894 1.37508 23.5995C1.72341 23.6095 2.06431 23.4976 2.33886 23.283L15.7387 15.6705",
    fill: "url(#paint2_linear_594_58)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7294 7.92961L2.32958 0.317129C2.05503 0.102525 1.71413 -0.00942591 1.3658 0.000622024C1.01748 0.01067 0.6836 0.142087 0.421875 0.372161L11.8589 11.8L15.7294 7.92961Z",
    fill: "url(#paint3_linear_594_58)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.6194 15.588L2.32969 23.1546C2.06489 23.3525 1.74314 23.4595 1.41252 23.4595C1.0819 23.4595 0.760149 23.3525 0.495354 23.1546L0.431152 23.2188L0.495354 23.283C0.759548 23.4824 1.08153 23.5902 1.41252 23.5902C1.74351 23.5902 2.06549 23.4824 2.32969 23.283L15.7295 15.6705L15.6194 15.588Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M0.431042 23.0995C0.132106 22.7408 -0.0187795 22.2816 0.00914484 21.8155V21.9531C-0.0187795 22.4192 0.132106 22.8784 0.431042 23.2371L0.495243 23.1729L0.431042 23.0995ZM20.2051 12.9924L15.6193 15.5879L15.7019 15.6705L20.2051 13.1208C20.4607 13.0007 20.68 12.8154 20.841 12.5835C21.0021 12.3517 21.0991 12.0814 21.1223 11.8C21.0707 12.0557 20.9612 12.2961 20.8022 12.5028C20.6432 12.7095 20.439 12.8769 20.2051 12.9924Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M2.3296 0.445182L20.2052 10.6074C20.439 10.7228 20.6433 10.8903 20.8023 11.097C20.9613 11.3037 21.0708 11.5441 21.1223 11.7997C21.0991 11.5183 21.0021 11.2481 20.8411 11.0162C20.68 10.7843 20.4607 10.599 20.2052 10.479L2.3296 0.316777C1.04557 -0.407784 0 0.197547 0 1.66501V1.80259C0.027515 0.32595 1.05474 -0.279379 2.3296 0.445182Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_594_58",
    x1: 10.85,
    y1: 1.44524,
    x2: -4.54,
    y2: 16.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_594_58",
    x1: 21.8835,
    y1: 11.8,
    x2: -0.30273,
    y2: 11.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_594_58",
    x1: 13.6292,
    y1: 13.9095,
    x2: -7.24552,
    y2: 34.7751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_594_58",
    x1: -2.44885,
    y1: -6.37818,
    x2: 6.86955,
    y2: 2.94022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.855102c126509d20de56064e9db1676a.svg";
export { ForwardRef as ReactComponent };